import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import Inquiry from '../components/support/Inquiry';

const InquiryPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <Inquiry />
            </main>

            <TopButton />
        </>
    );
};

export default InquiryPage;